module.exports = __webpack_public_path__ + "img/banner1_6.475d714a.png";